import * as trackingEvents from "@goodgamestudios/tracking-event-types";
import {BasicModel} from "../../basic/model/BasicModel";
import {int} from "@goodgamestudios/math-utilities";
import {EnvGlobalsHandler} from "../../basic/EnvGlobalsHandler";
import {BasicTrackingEvent} from "../BasicTrackingEvent";

export class ClientFunnelTrackingEvent extends BasicTrackingEvent {
    public stage: string = "";
    public gamestate_name: string = "";
    public playerId: number = -1;
    public account_hash: string = "TestHash";
    public gamestate_count_session: number = 1; // should start at 1 due to specific reason defined by BI
    public session_count: number = 0;
    public media_partner_id: number = -1;
    public website_id: number = -1;
    public session_type_name: string = "UNKNOWN";
    public device_language_code: string = "";
    public client_version: string = "";


    /*override*/
    public getVars(): trackingEvents.ClientFunnel.Event {
        const vars: trackingEvents.ClientFunnel.Event = {
            eventId: trackingEvents.ClientFunnel.ID,
            event_mapping_version: 2,
            playerId: BasicModel.userData ? BasicModel.userData.playerID : -1,
            client_timestamp: int(new Date().getTime() / 1000),
            account_hash: this.account_hash,
            device_id: 1,
            platform_id: 1,
            device_language_code: this.device_language_code,
            session_type_name: this.session_type_name,
            session_count: this.session_count,
            gamestate_name: this.gamestate_name,
            gamestate_count_session: this.gamestate_count_session++,
            session_length_ms: EnvGlobalsHandler.globals.sessionLength * 1000,
            client_version: this.client_version,
            client_language_code: EnvGlobalsHandler.globals.currentCountryLanguageCode ? EnvGlobalsHandler.globals.currentCountryLanguageCode  : "UNKNOWN" ,
            referrer_name: this.referrer.substr(0, 99),
            is_html5: 1
        };

        // fields that are required but not yet added to the Tracking-Definition (which are converted to Tracking Runtypes
        (<any>vars).user_agent= navigator.userAgent || "Not available";
        // optional fields

        if (this.website_id >= 0) {
            vars.website_id = this.website_id;
        }

        if (this.media_partner_id > 0) {
            vars.media_partner_id = this.media_partner_id;
        }


        return vars;
    }
}
